import Divider from '@mui/material/Divider';
import { noddiColors } from 'noddi-ui-common';

export const SideNavDivider = ({ className }: { className?: string }) => (
  <Divider
    className={className}
    sx={{ backgroundColor: noddiColors.white, height: '1px', opacity: 0.8, width: '100%' }}
  />
);
